import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Courses from "@/pages/Courses";
import CourseDetail from "@/pages/CourseDetail";
import Dashboard from "@/pages/Dashboard";
import Coach from "@/pages/Coach";
import Radar from "@/pages/Radar";
import PayPix from "@/pages/PayPix";
import Admin from "@/pages/Admin";
import Achievements from "@/pages/Achievements";
import Ranking from "@/pages/Ranking";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import SupportSection from "@/components/SupportSection";
import InstallBanner from "@/components/InstallBanner";
import { RequireSub } from "@/components/RequireSub";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Navbar/>
          <Routes>
            <Route path="/" element={<Landing/>}/>
            <Route path="/login" element={<Login/>}/>
            <Route path="/register" element={<Register/>}/>
            <Route path="/forgot-password" element={<ForgotPassword/>}/>
            <Route path="/reset-password" element={<ResetPassword/>}/>
            <Route path="/cursos" element={<Courses/>}/>
            <Route path="/cursos/:id" element={<CourseDetail/>}/>
            <Route path="/dashboard" element={<RequireSub><Dashboard/></RequireSub>}/>
            <Route path="/coach" element={<RequireSub><Coach/></RequireSub>}/>
            <Route path="/missao" element={<RequireSub><Radar/></RequireSub>}/>
            <Route path="/pagar/pix" element={<PayPix/>}/>
            <Route path="/admin" element={<Admin/>}/>
            <Route path="/conquistas" element={<RequireSub><Achievements/></RequireSub>}/>
            <Route path="/ranking" element={<RequireSub><Ranking/></RequireSub>}/>
            <Route path="/payment/success" element={<PaymentSuccess/>}/>
            <Route path="/payment/cancel" element={<PaymentCancel/>}/>
          </Routes>
          <SupportSection/>
          <InstallBanner/>
          <footer className="border-t-2 border-white/20 py-10 px-4 md:px-8 text-center">
            <div className="font-bebas text-3xl tracking-tighter">CRIA<span className="text-[#CCFF00]">.</span>FINANCE</div>
            <p className="mt-2 text-white/40 font-manrope text-sm">Feito pra cria, por cria. © 2026</p>
            <p className="mt-1 text-white/30 font-manrope text-xs">Contato: cria.finance@gmail.com</p>
          </footer>
          <Toaster theme="dark" position="top-right" toastOptions={{style:{background:'#0A0A0A', color:'#F5F5F5', border:'2px solid #CCFF00', borderRadius:0, fontFamily:'Manrope'}}}/>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
